import { IOnInit } from "angular";

import angular from "angular";
import { IReportGroup } from "../../../../reporting/interfaces/IReportGroup";
import { MachineConfigurationView } from "../../models/machineConfiguration";

export class MachinesChangeViewController implements IOnInit {
  static $inject = [];

  /* start bindings */
  readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  readonly resolve!: any;
  machineConfigurations!: MachineConfigurationView[];
  ChangeId: any;
  reportGroup!: IReportGroup;
  /* end binding */

  constructor() {}

  $onInit(): void {
    this.machineConfigurations = this.resolve.machineConfigurations;
    this.ChangeId = this.resolve.ChangeId;
    this.reportGroup = this.resolve.reportGroup;
  }
}
